var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.103 25.0017C16.103 20.0904 20.0845 16.1089 24.9959 16.1089C29.9073 16.1089 33.8887 20.0904 33.8887 25.0017V31.216H16.103V25.0017Z",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0298 33.8375C15.0298 32.6245 16.0132 31.6411 17.2262 31.6411H32.7619C33.975 31.6411 34.9584 32.6245 34.9584 33.8375C34.9584 35.0506 33.975 36.034 32.7619 36.034H17.2262C16.0132 36.034 15.0298 35.0506 15.0298 33.8375Z",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9335 22.8632C20.5002 21.5191 21.5777 20.4552 22.9288 19.9055",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3754 16.2938C19.4872 14.4447 22.1992 13.4263 25.0061 13.4282C27.813 13.4301 30.5235 14.4523 32.6328 16.3042",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9237 14.9237C16.247 13.6005 17.8179 12.5508 19.5468 11.8347C21.2756 11.1186 23.1287 10.75 25 10.75C26.8713 10.75 28.7243 11.1186 30.4532 11.8347C32.1821 12.5508 33.753 13.6005 35.0763 14.9237",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.649b47dfbdba914752a23f57e082b26d.svg";
export { ForwardRef as ReactComponent };